import { listingMagasinMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';
import { Block } from '@shared/models';

const blocks: Block<unknown>[] = [];

export const listingMagasinPageMock = (type: 'region' | 'dept' | 'all'): SlugPage => ({
  ...pageBase({
    title: 'Listing Magasin',
    type: 'magasin',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks: [...blocks, listingMagasinMock(type)],
});
